import { Injectable, inject, signal } from '@angular/core';
import { MediaDevicesGateway } from '@jump-tech-frontend/media-capture';
import { isLocalFeatureFlagEnabled } from './local-feature-flag';

export const TORCH_CAPTURE_FLAG = 'relay-torch-capture-enabled';

@Injectable({ providedIn: 'root' })
export class TorchCaptureSettings {
  private readonly devices = inject(MediaDevicesGateway);
  private readonly ruledOut = signal(false);
  private backendEnabled = false;
  private localOverride: boolean | null = null;

  public setBackendEnabled(enabled: boolean): void {
    this.backendEnabled = enabled;
  }

  public isEnabled(): boolean {
    this.localOverride ??= isLocalFeatureFlagEnabled(TORCH_CAPTURE_FLAG);
    return this.backendEnabled || this.localOverride;
  }

  public isAvailable(): boolean {
    return !this.ruledOut() && this.isEnabled() && this.devices.isCameraAvailable();
  }

  public ruleOut(): void {
    this.ruledOut.set(true);
  }
}
